import { Autocomplete, Switch, TextField } from '@mui/material';
import React, { useEffect, useState } from 'react'
import { useAppData } from '../../../../../context/AppDataContext';
import { Add, Delete } from '@mui/icons-material';
import { useAlert } from '../../../../../context/AlertContext';
import transactionServices from '../transactionServices';





export const ProjectTransactionAllocationForm = ({transactionAmount,projectTransactionList,setProjectTransactionList,totalAlloted,setTotalAlloted}) => {
    const {transactionCategoryDD,employeeDD,vendorDD,projectDD} = useAppData();
    const {AppAlert} = useAlert();

    const [suggestionList,setSuggestionList] = useState([]);

    const prepareSuggestionList = () =>{
        let _employList = employeeDD.map(employee=>"EMP-"+employee.value+" : "+employee.label);
        let _vendorList = vendorDD.map(vendor=>"VND-"+vendor.value+" : "+vendor.label);

        console.log("employee list",_employList);
        console.log("vendor list",_vendorList);
        setSuggestionList([..._employList,..._vendorList]);
    }

    useEffect(()=>{
        prepareSuggestionList();
    },[])

    const [selectedProject,setSelectedProject] = useState(null);

    const addProject = () =>{
        if(selectedProject !== null && selectedProject !== ""){
            //let _project = {...selectedProject};
            let _project = {
                projectId : selectedProject.value,
                label : selectedProject.label,
                transactionCategory:"",
                payeeType:"",
                paidTo:"",
                payeeName:"",
                amount:""
            };
            let _projectTransactionList = [...projectTransactionList,_project];
            setProjectTransactionList(_projectTransactionList)
        }
    }


    const removeProject = (index) =>{
        let _projectTransactionList = projectTransactionList.filter((p,i)=>i!= index);
        setProjectTransactionList(_projectTransactionList);

        let projectedTotal = _projectTransactionList.reduce((sum, item, index) => {
            return sum + (Number(item.amount) || 0);
        }, 0);

        setTotalAlloted(projectedTotal)
    }

    const setInputAmount = (i, amt) => {
        let amount = Number(amt) || 0; // Use 0 instead of "" for math safety
        let _projectTransactionList = [...projectTransactionList];

        // 1. Calculate the total of OTHER items (excluding the one being edited)
        let totalOfOthers = _projectTransactionList.reduce((sum, item, index) => {
            return index === i ? sum : sum + (Number(item.amount) || 0);
        }, 0);

        // 2. Calculate what the new total WOULD be
        let projectedTotal = totalOfOthers + amount;

        // Validation Logic
        if (projectedTotal <= transactionAmount) {
            _projectTransactionList[i]['amount'] = amount;
            setProjectTransactionList(_projectTransactionList);
            setTotalAlloted(projectedTotal);
        } else {
            AppAlert("Total Amount should not exceed transaction amount", 'error');
        }
    };


    const setPayeeType = (i,value) =>{
        let _projectTransactionList = [...projectTransactionList];
        _projectTransactionList[i]["payeeType"] = value;
        _projectTransactionList[i]["paidTo"] = "";
        _projectTransactionList[i]["payeeName"] = "";

        setProjectTransactionList(_projectTransactionList);
    }
    
    const setPaidTo = (i,value) =>{
        let _projectTransactionList = [...projectTransactionList];
        _projectTransactionList[i]["paidTo"] = value;
        setProjectTransactionList(_projectTransactionList);
    }

    const setPayeeName = (i,value) =>{
        let _projectTransactionList = [...projectTransactionList];
        _projectTransactionList[i]["payeeName"] = value;
        setProjectTransactionList(_projectTransactionList);
    }

    const setTransactionCategory = (i,value) =>{
        let _projectTransactionList = [...projectTransactionList];
        _projectTransactionList[i]["transactionCategory"] = value;
        setProjectTransactionList(_projectTransactionList);
    }
    
    return (
        <table className='table table-bordered table-striped'>
            <thead>
                <tr className='table-primary'>
                    <th>Selct Projetct</th>
                    <th colSpan={4} className='text-center'>
                        <Autocomplete
                            options={projectDD}
                            onChange={(event, newValue) => {
                                setSelectedProject(newValue);
                            }}
                            className='bg-white'
                            value={selectedProject}
                            renderInput={(params) => <TextField {...params} size="small" /> } 
                        />
                    </th>
                    <th>
                        <button type='button' className='btn btn-primary' onClick={addProject} ><Add/></button>
                    </th>
                </tr>
                <tr>
                    <th>Project Name</th>
                    <th width={"20%"}>Transection Category</th>
                    <th width={"10%"}>Payee Type</th>
                    <th width={"25%"}>Paid To</th>
                    <th width={"10%"}>Amount</th>
                    <th width={"5%"}></th>
                </tr>
            </thead>
            <tbody>
                {projectTransactionList.map((project,i)=>
                    <tr key={i}>
                        <td>{project.label}</td>
                        <td>
                                <Autocomplete
                                    options={transactionCategoryDD}
                                    onChange={(event, newValue) => {
                                        setTransactionCategory(i,newValue);
                                    }}
                                    value={projectTransactionList[i].transactionCategory}
                                    renderInput={(params) => <TextField {...params} size="small"  /> } 
                                    //renderInput={(params) => <TextField {...params} size="small" //onChange={(e)=>setInputData(i,e.target.value)} /> } 
                                />
                        </td>

                        <td >
                            <div className="form1-floating mb-3">
                                <select className="form-control"
                                    onChange={(e)=> 
                                        setPayeeType(i,e.target.value)
                                    }
                                >
                                    {transactionServices.payeeTypeList.map(payeeType=>
                                        <option value={payeeType.value}>{payeeType.label}</option>
                                    )}
                                </select>
                                {/* <label>Select Payee Type</label> */}
                            </div>
                        </td>
                        <td >
                            {projectTransactionList[i].payeeType == 1 &&
                                <Autocomplete
                                    options={employeeDD}
                                    onChange={(event, newValue) => {
                                        setPaidTo(i,newValue);
                                    }}
                                    value={projectTransactionList[i].paidTo}
                                    renderInput={(params) => <TextField {...params} size="small"  /> } 
                                    //renderInput={(params) => <TextField {...params} size="small" //onChange={(e)=>setInputData(i,e.target.value)} /> } 
                                />
                            }
                            {projectTransactionList[i].payeeType == 2 &&
                                <Autocomplete
                                    options={vendorDD}
                                    onChange={(event, newValue) => {
                                        setPaidTo(i,newValue);
                                    }}
                                    value={projectTransactionList[i].paidTo}
                                    renderInput={(params) => <TextField {...params} size="small"  /> } 
                                    //renderInput={(params) => <TextField {...params} size="small" //onChange={(e)=>setInputData(i,e.target.value)} /> } 
                                />
                            }
                            {projectTransactionList[i].payeeType == 11 &&

                                <input type="text" className='form-control' value={project.payeeName}
                                    onChange={(e)=>setPayeeName(i,e.target.value)}
                                />
                            }
                        </td>
                        <td>
                            <input type="number" className='form-control' value={project.amount}
                                onChange={(e)=>setInputAmount(i,e.target.value)}
                            />
                        </td>
                        <td>
                            <button className='btn btn-danger btn-sm' type='button' onClick={()=>removeProject(i)} > <Delete/></button>
                        </td>
                    </tr>
                )}
            </tbody>
            
            <tfoot>
                <tr>
                    <td></td>
                    <td></td>
                    <td></td>
                    <th>Alloted</th>
                    <th>
                        {totalAlloted} / {transactionAmount}
                    </th>
                    <th></th>
                    
                </tr>
                <tr>
                    <td colSpan={6}>
                        {/*JSON.stringify(projectTransactionList)*/}
                    </td>
                </tr>
            </tfoot>

        </table>

        
    )
}